<!--课程学习记录-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
    v-loading="loading"
    element-loading-text="文件导出中..."
    element-loading-background="rgba(122, 122, 122, 0.8)"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="课程名称">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.title"
                    placeholder="课程名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="用户姓名">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.name"
                    placeholder="用户姓名"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    id="Name"
                    v-model="PageQuery.queryModel.phone"
                    placeholder="手机号"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="show" :gutter="24">
              <el-col :span="12">
                <el-form-item label="省-市">
                  <el-select
                    style="width: 49%"
                    v-model="SelectData.provinceId"
                    filterable
                    placeholder="请选择省"
                    @change="ProvinceChange"
                  >
                    <el-option
                      v-for="item in ProvinceList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>

                  <el-select
                    style="width: 50%"
                    v-model="SelectData.cityId"
                    filterable
                    placeholder="请选择市"
                  >
                    <el-option
                      v-for="item in CityList"
                      :key="item.id"
                      :label="item.areaName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="课程分类">
                  <el-cascader
                    v-model="categoryIds"
                    v-loading="loading"
                    :options="options"
                    :props="props"
                    :show-all-levels="false"
                    style="width: 100%"
                    collapse-tags-tooltip
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>

      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in UnitList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
              />
            </template>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
import { CourseRecordList } from "@/assets/apiData/CourseRecord";
import { GetDataCourseRecordList } from "@api/ApiCourseRecord";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { ProvinceList } from "@/assets/apiData/Province";
import { GetDataCourseCategoryList } from "@api/Company/ApiUser";
export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
          phone: "",
          title: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      UnitList: [],
      DataList: [],
      loading: false,
      ProvinceList: [],
      CityList: [],
      SelectData: {
        provinceId: "",
        cityId: "",
      },
      props: {
        multiple: true,
        expandTrigger: "hover",
        value: "id",
        label: "name",
        children: "childs",
      },
      categoryIds: [],
      options: [],
    };
  },
  components: {
    excel,
    Search,
  },
  methods: {
    getCategoryList() {
      const params = {
        pageSize: 10000,
        pageIndex: 1,
        queryModel: {},
      };
      GetDataCourseCategoryList(params).then((res) => {
        this.options = res;
      });
    },
    ProvinceChange() {
      this.SelectData.cityId = "";
      this.ProvinceList.map((x) => {
        if (x.id == this.SelectData.provinceId) {
          this.CityList = JSON.parse(
            JSON.stringify(x.children.filter((o) => o.level == 3))
          );
          this.CityList.unshift({
            areaName: "-请选择-",
            id: "",
          });
        }
      });
    },
    export2Excel() {
      const v = this;
      v.loading = true;
      GetDataCourseRecordList({
        ...v.PageQuery,
        ...{
          PageSize: v.total,
        },
      }).then(function (res) {
        v.loading = false;
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径
          const tHeader = [
            ...Enumerable.from(v.UnitList)
              .select((item) => {
                return item.label;
              })
              .toArray(),
          ]; // 标题
          const filterVal = [
            ...Enumerable.from(v.UnitList)
              .select((item) => {
                return item.prop;
              })
              .toArray(),
          ]; // 导出的字段名
          const list = res.entities;
          const data = v.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, `课程学习记录`);
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.GetData();
    },
    GetData() {
      const categoryIds = this.categoryIds.map((item) => item[item.length - 1]);
      this.PageQuery.queryModel = {
        ...this.PageQuery.queryModel,
        ...this.SelectData,
        ...{ categoryIds },
      };
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataCourseRecordList(_this.PageQuery).then(function (data) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    SearchDataInfo() {},
  },
  created() {
    this.ProvinceList = JSON.parse(JSON.stringify(ProvinceList.entities));
    this.ProvinceList.unshift({
      areaName: "-请选择-",
      code: "",
    });
    this.getCategoryList();
    this.UnitList = CourseRecordList;
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
